module.exports = __webpack_public_path__ + "img/timeline-02a.d5b71d4f.jpg";